import { config } from "./config.js";

var utils = {
    log: function(object) {
        if (config.debug) {
            console.log(object);
        }
    },
    toTitleCase: function(str) {
        return str.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    },
    getNewVehicle: function() {
        return {
            year: null,
            make: null,
            model: null,
            trim: null,
            annualMileage: null,
            selected: null,
            daysDrivenPerWeek: null,
            ownershipType: null,
            primaryUseType: null,
            vin: null
        };
    }
};

export { utils }
